import { LIVE_DAY } from "@data/utility/liveDay"

export const BANNER_GO = Object.freeze({
    JOIN_LIVE: "join_live",
    CHOOSE_LIVE_OR_SAM: "choose_live_or_sam",
    STUDY_WITH_SAM: "study_with_sam",
    RELOAD: "reload",
    REFUSE: "refuse",
    NOTHING: "nothing",
})

// What GO on the home banner does, from the live's day read at the press. A
// Sam banner on the live day is a screen left from the day before: the
// student may have meant Sam, so they choose. The Sam banner only shows off
// a live day, so it never reloads: only a refusal is worth checking again.
export function bannerGoAnswer({ liveDay, onSamBanner, canReload }) {
    if (liveDay === LIVE_DAY.TODAY) {
        return onSamBanner ? BANNER_GO.CHOOSE_LIVE_OR_SAM : BANNER_GO.JOIN_LIVE
    }
    if (onSamBanner) return BANNER_GO.STUDY_WITH_SAM
    if (canReload) return BANNER_GO.RELOAD
    return liveDay === LIVE_DAY.FUTURE ? BANNER_GO.REFUSE : BANNER_GO.NOTHING
}
